import React from 'react'
// import MISAfterApproval from './components/MISAfterApproval'
import MarketCommitteeDashboard from './components/MISAfterApproval'
import { ToastContainer } from 'react-toastify'

const MISAfterApprovalHO = () => {
  return (
    <div className='page-wrapper'>
       <MarketCommitteeDashboard />

      <ToastContainer position="top-right" autoClose={3000} />

    </div>
    
  )
}

export default MISAfterApprovalHO